// extracted by mini-css-extract-plugin
module.exports = {"headerThumbs":"style__headerThumbs__hUSZU","legend":"style__legend__FeK+N"};